import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
// import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: "detailListTeacher",

    components: {
        MainLayout,
        StarRating,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            routeType: "",
            teacher: {},
            school: {},
            courses: {},
            lastPage: "",
            currentPage: "",
            routeId: this.$route.params.id,
            apeiron_id: process.env.VUE_APP_APEIRON_ID,
            gm_id: process.env.VUE_APP_GM_ID,
            pnse_id: process.env.VUE_APP_PNSE_ID,
            fs_id: process.env.VUE_APP_FS_ID,
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getDetailListTeacher() {
            axios.get("/teacher/" + this.$route.params.id)
                .then((response) => {
                    this.teacher = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Teacher Detail API Error", error);
                });
        },

        getDetailListSchool() {
            axios.get("/school/" + this.$route.params.id)
                .then((response) => {
                    this.school = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("School Detail API Error", error);
                });
        },

        getCourseBySchoolId(page = 1) {
            axios.get("school/" + this.$route.params.id + "/course/list?page=" + page)
                .then((response) => {
                    this.courses = response.data;
                    this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course List API error", error);
                });
        },
        
        getCourseByTeacherId(page = 1) {
            axios.get("teacher/" + this.$route.params.id + "/course/list?page=" + page)
                .then((response) => {
                    this.courses = response.data;
                    this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course List API error", error);
                });
        },

        apkDownload() {
            if (this.routeId == this.apeiron_id) {
                window.location.href = 'https://bucketscm.s3.ap-southeast-1.amazonaws.com/bib/sms/apeiron/apeiron_school.apk';
            } else if (this.routeId == this.gm_id) {
                window.location.href = 'https://bucketscm.s3.ap-southeast-1.amazonaws.com/bib/sms/gmother/gmother_school.apk';
            } else if (this.routeId == this.pnse_id) {
                window.location.href = 'https://bucketscm.s3.ap-southeast-1.amazonaws.com/bib/sms/pnse/Pyin Nyar San Eain Mobile.apk';
            } else if (this.routeId == this.fs_id) {
                window.location.href = 'https://bucketscm.s3.ap-southeast-1.amazonaws.com/bib/sms/futurestep/fs_school.apk';
            }
            // axios.get("teacher/apkDownload/" + this.routeId)
            //     .then(response => {
            //         const blob = new Blob([this.base64ToArrayBuffer(response.data.contents)], { type: 'application/vnd.android.package-archive' });
            //         const link = document.createElement('a');
            //         link.href = window.URL.createObjectURL(blob);
            //         link.setAttribute('download', appName);
            //         document.body.appendChild(link);
            //         link.click();
            //     })
            //     .catch(error => {
            //         if (error) {
            //             if (error.response && error.response.status == 404) {
            //                 this.$notification.error("APK မရှိသေးပါ။", {
            //                     timer: 3,
            //                     position: 'bottomCenter'
            //                 });
            //             }
            //         }
            //     })
        },
        // base64ToArrayBuffer(base64) {
        //     const binaryString = window.atob(base64);
        //     const len = binaryString.length;
        //     const bytes = new Uint8Array(len);
        //     for (let i = 0; i < len; i++) {
        //         bytes[i] = binaryString.charCodeAt(i);
        //     }
        //     return bytes.buffer;
        // }

        callByRouteType () {
            if (this.routeType == 'school') {
                this.getDetailListSchool();
                this.getCourseBySchoolId();
            } else if (this.routeType == 'teacher') {
                this.getDetailListTeacher();
                this.getCourseByTeacherId();
            }
        }
    },

    created() {
        this.routeType = this.$route.meta.type;
        this.callByRouteType();
        // fetchNotificationCount();
    }
};
